import {
  Box,
  Heading,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  Alert,
  AlertIcon,
  Center,
  Spinner,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
} from '@chakra-ui/react';
import { FaChevronDown } from 'react-icons/fa';
import { useState } from 'react';

export const TransactionTables = ({
  pointsData,
  stampsData,
  loading,
  error,
  isStamps = false,
  onRangeChange, // callback to notify parent to fetch new data
  selectedRange = 'today' // current selected range from parent
}) => {
  const [range, setRange] = useState(selectedRange);

  const handleRangeChange = (newRange) => {
    setRange(newRange);
    onRangeChange?.(newRange); // Notify parent to fetch with new range
  };

  const data = isStamps ? stampsData : pointsData;

  if (loading) {
    return (
      <Center h="200px">
        <Spinner size="xl" />
      </Center>
    );
  }

  if (error) {
    return (
      <Alert status="error" borderRadius="md" mb={4}>
        <AlertIcon />
        Error loading {isStamps ? 'stamps' : 'points'} data
      </Alert>
    );
  }

  const capitalizedRange = range.charAt(0).toUpperCase() + range.slice(1);

  const tables = [
    {
      title: `${capitalizedRange} ${isStamps ? 'Stamps' : 'Points'} Earned`,
      data: data?.data || [],
      columns: ["User", isStamps ? "Stamps" : "Points", ...(isStamps ? [] : ["Amount"]), "Added By"]
    },
    {
      title: `${capitalizedRange} ${isStamps ? 'Stamps' : 'Points'} Redeemed`,
      data: data?.todaysRedeemeds || [],
      columns: ["User", "Reward", isStamps ? "Stamps" : "Points", ...(isStamps ? [] : ["Amount"]), "Added By"]
    }
  ];

  return (
    <>
      <Box mb={4} textAlign="right">
        <Menu>
          <MenuButton as={Button} rightIcon={<FaChevronDown />}>
            {capitalizedRange}
          </MenuButton>
          <MenuList>
            {['today', 'week', 'month', 'year'].map((option) => (
              <MenuItem key={option} onClick={() => handleRangeChange(option)}>
                {option.charAt(0).toUpperCase() + option.slice(1)}
              </MenuItem>
            ))}
          </MenuList>
        </Menu>
      </Box>

      {tables.map((table, index) => (
        <Box key={index} mb={6}>
          <Heading as="h4" size="sm" mb={4}>
            {table.title}
          </Heading>
          {table.data.length > 0 ? (
            <Box overflowX="auto">
              <Table variant="simple" size="sm">
                <Thead>
                  <Tr>
                    {table.columns.map((col, i) => (
                      <Th key={i}>{col}</Th>
                    ))}
                  </Tr>
                </Thead>
                <Tbody>
                  {table.data.map((item, i) => (
                    <Tr key={i}>
                      <Td>{item.userName}</Td>
                      {table.title.includes('Redeemed') && (
                        <Td>{item.rewardTitle || 'Unknown'}</Td>
                      )}
                      <Td fontWeight="bold">
                        {Math.abs(isStamps ? item.stamps : item.points).toLocaleString()}
                      </Td>
                      {!isStamps && <Td fontWeight="bold">{item.amount}</Td>}
                      <Td>{item.addedByNames}</Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </Box>
          ) : (
            <Text color="gray.500" textAlign="center" py={4}>
              No {table.title.toLowerCase()} recorded
            </Text>
          )}
        </Box>
      ))}
    </>
  );
};


// import {
//     Box,
//     Heading,
//     Table,
//     Thead,
//     Tbody,
//     Tr,
//     Th,
//     Td,
//     Text,
//     Alert,
//     AlertIcon,
//     Center,
//     Spinner
//   } from '@chakra-ui/react';
  
//   export const TransactionTables = ({ 
//     pointsData, 
//     stampsData, 
//     loading, 
//     error, 
//     isStamps = false 
//   }) => {
//     const data = isStamps ? stampsData : pointsData;
    
//     if (loading) {
//       return (
//         <Center h="200px">
//           <Spinner size="xl" />
//         </Center>
//       );
//     }
  
//     if (error) {
//       return (
//         <Alert status="error" borderRadius="md" mb={4}>
//           <AlertIcon />
//           Error loading {isStamps ? 'stamps' : 'points'} data
//         </Alert>
//       );
//     }
  
//     const tables = [
//       { 
//         title: `Today ${isStamps ? 'Stamps' : 'Points'} Earned`, 
//         data: data?.data || [], 
//         columns: ["User", isStamps ? "Stamps" : "Points", ...(isStamps ? [] : ["Amount"]), "Added By"] 
//       },
//       { 
//         title: `Today ${isStamps ? 'Stamps' : 'Points'} Redeemed`, 
//         data: data?.todaysRedeemeds || [], 
//         columns: ["User", "Reward", isStamps ? "Stamps" : "Points", ...(isStamps ? [] : ["Amount"]), "Added By"] 
//       }
//     ];
  
//     return (
//       <>
//         {tables.map((table, index) => (
//           <Box key={index} mb={6}>
//             <Heading as="h4" size="sm" mb={4}>
//               {table.title}
//             </Heading>
//             {table.data.length > 0 ? (
//               <Box overflowX="auto">
//                 <Table variant="simple" size="sm">
//                   <Thead>
//                     <Tr>
//                       {table.columns.map((col, i) => (
//                         <Th key={i}>{col}</Th>
//                       ))}
//                     </Tr>
//                   </Thead>
//                   <Tbody>
//                     {table.data.map((item, i) => (
//                       <Tr key={i}>
//                         <Td>{item.userName}</Td>
//                         {table.title.includes("Redeemed") && <Td>{item.rewardTitle || 'Unknown'}</Td>}
//                         <Td fontWeight="bold">
//                           {Math.abs(isStamps ? item.stamps : item.points).toLocaleString()}
//                         </Td>
//                         {!isStamps && <Td fontWeight="bold">{item.amount}</Td>}
//                         <Td>{item.addedByNames}</Td>
//                       </Tr>
//                     ))}
//                   </Tbody>
//                 </Table>
//               </Box>
//             ) : (
//               <Text color="gray.500" textAlign="center" py={4}>
//                 No {table.title.toLowerCase()} recorded
//               </Text>
//             )}
//           </Box>
//         ))}
//       </>
//     );
//   };